import { render } from "./ExtraChargeCategoryIndex.vue?vue&type=template&id=29c7b41e"
import script from "./ExtraChargeCategoryIndex.vue?vue&type=script&lang=js"
export * from "./ExtraChargeCategoryIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__